import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { WEB_APP_ORIGIN } from '../storeConfig';
import DeepLinkShell from '../DeepLinkShell';
import SmartAppCta from '../SmartAppCta';

/**
 * Affiliate marketing referral on the app host.
 * Canonical affiliate UX remains www `/ref/:code`; this mirrors open-app CTAs
 * and stores the code for web signup continuity.
 */
const AffiliateRefLanderPage: React.FC = () => {
  const { code } = useParams<{ code: string }>();

  useEffect(() => {
    if (!code) return;
    const upper = code.toUpperCase();
    try {
      sessionStorage.setItem('affiliateReferralCode', upper);
      if (document.cookie !== undefined) {
        const expiry = new Date();
        expiry.setDate(expiry.getDate() + 30);
        document.cookie = `affiliateReferralCode=${upper}; expires=${expiry.toUTCString()}; path=/; SameSite=Lax`;
      }
    } catch {
      /* ignore */
    }
  }, [code]);

  return (
    <DeepLinkShell>
      <div className="dl-card">
        <h1 className="dl-name">Welcome to LookBel</h1>
        <p className="dl-meta">Your invite code:</p>
        <p className="dl-code">{code || '—'}</p>
        <SmartAppCta
          title="Get the app"
          subtitle="Download LookBel and enter this code when you sign up."
          webHref={`${WEB_APP_ORIGIN}/ref/${encodeURIComponent(code || '')}`}
          webLabel="Continue on the website"
        />
      </div>
    </DeepLinkShell>
  );
};

export default AffiliateRefLanderPage;
